<template>
  <div class="DataCategorisationLeftSection">
    <div class="filter-section">
      <data-categorisation-carousel />
      <NewsSectionComponent @open-news-popup="showNewsPopup" />

      <!-- Use the component without `.sync` -->
      <NewsPopupComponent :isVisible="isNewsPopupVisible" :newsData="selectedNews" @update:isVisible="isNewsPopupVisible = $event" />

      <!-- Banner Section -->
      <div class="banner-section">
        <SAchatCommingSoonBanner />
      </div>
      <!-- <markets-top-5 /> -->
    </div>
  </div>
</template>

<script>
import DataCategorisationCarousel from '@/components/DataCategorisationCarousel.vue';
import MarketsTop5 from '@/components/MarketsTop5.vue';
import NewsSectionComponent from '@/components/NewsSectionComponent.vue';
import NewsPopupComponent from '@/components/NewsPopupComponent.vue';
import SAchatCommingSoonBanner from '@/components/SAchatCommingSoonBanner.vue';
import moment from 'moment';

export default {
  name: 'DataCategorisationLeftSection',

  components: {
    DataCategorisationCarousel,
    MarketsTop5,
    SAchatCommingSoonBanner,
    NewsSectionComponent,
    NewsPopupComponent
  },
  data() {
    return {
      isNewsPopupVisible: false,
      selectedNews: null,
    };
  },
  methods: {
    showNewsPopup(news) {
      // console.log("Popup Event Received:", news);
      this.selectedNews = news;
      this.isNewsPopupVisible = true;
    },
    formatDate(date) {
      return moment(date).format("MMM DD, YYYY hh:mm A");
    }
  },
  watch: {
    isNewsPopupVisible(newVal) {
      // console.log("Popup visibility changed:", newVal);
    }
  }
};
</script>
